import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import DOMPurify from "dompurify";
import { useAuth } from "./../../context/AuthContent";
import { addToCartLocal } from "./../../config/commonfunctions/AddToCart";
// COMPONENT FOR RENDERING PRODUCTS PRICING AND DECIDING ITS LAYOUT FROM ONE PLACE
import ProductPricing from "./../../pages/Components/ProductPricing";

function ProductSlider({ categoryName, relatedProducts, backurl }) {
  const { refreshCartCount } = useAuth();
  const productSliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <div className="row">
      <div className="col-lg-12 mb-30">
        <h3 className="text-center">Explore Products Under {categoryName}</h3>
      </div>

      <div className="col-lg-12">
        <Slider {...productSliderSettings}>
          {relatedProducts.map((sub) => {
            let foldername = sub.product_name
              .replaceAll(" ", "_")
              .toLowerCase();
            return (
              <div key={sub.id} className="px-15">
                <div className="prt-featured-box text-center p-25 border-rad_20 h-100">
                  <img
                    src={`${backurl}shop_product_listing/${foldername}/${sub.product_images.split("|")[0]}_large.webp`}
                    alt={sub.product_name}
                    className="products-slider-img img-fluid mb-15 rounded"
                  />

                  <h5 className="mb-10">{sub.product_name}</h5>

                  <p>
                    <ProductPricing ProductPrice={sub.price} />
                  </p>
                  <p
                    className="mb-15"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(sub.short_description || ""),
                    }}
                  ></p>

                  <div className="d-flex justify-content-around prt-product-btn">
                    <Link
                      className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor mr"
                      to={`/product${sub.product_url}`}
                    >
                      View
                    </Link>
                    <button
                      className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                      onClick={async () => {
                        addToCartLocal(sub);
                        await refreshCartCount();
                      }}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}

export default ProductSlider;
